import Header from "@/components/landing/Header";
import VisaSection from "@/components/landing/VisaSection";
import Footer from "@/components/landing/Footer";
import Seo from "@/components/Seo";

export default function VisaIndex() {
  return (
    <>
      <Seo
        title="Visa & Green Card: E-2, EB-2 NIW, EB-1C und L-1A im Überblick"
        description="Ihr Visum für die USA: E-2 Unternehmervisum, EB-2 NIW und EB-1C direkt zur Green Card oder L-1A für Führungskräfte – wir prüfen, welcher Weg zu Ihnen passt."
        keywords="Visum USA, E-2 Visum, EB-2 NIW, EB-1C, L-1A Visum, Green Card USA, Visumsberatung USA, Auswandern Florida"
      />
      <Header />
      <main className="pt-20" data-testid="visa-index-page">
        <VisaSection />
      </main>
      <Footer />
    </>
  );
}
